import React from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import { Navbar2, Footer2 } from "../../components";
import { getRouteMeta } from "../../seoData";

const CASES = [
  {
    to: "/cases/case-001-cracked-tool-beaconing/",
    id: "Case 001",
    title: "Simulated Cracked-Tool Download and C2 Beaconing",
    text: "A planted \"cracked tool\" is downloaded from a local web server and run on a domain-joined client. It beacons to a fake C2. Investigated from logs, memory, and disk.",
    status: "Planned",
    statusClass: "case-chip--planned",
    tools: ["Loki", "FTK Imager", "Volatility 3", "Autopsy"],
    docs: ["Incident report", "Chain of custody", "IR form", "Hash list"],
  },
];

function Cases() {
  const { title, description: desc, image, url } = getRouteMeta("/cases");

  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={desc} data-react-helmet="true"></meta>

        <meta property="og:type" content="website" data-react-helmet="true"></meta>
        <meta property="og:url" content={url} data-react-helmet="true"></meta>
        <meta property="og:title" content={title} data-react-helmet="true"></meta>
        <meta property="og:description" content={desc} data-react-helmet="true"></meta>
        <meta property="og:image" content={image} data-react-helmet="true"></meta>

        <meta property="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:url" content={url} data-react-helmet="true"></meta>
        <meta property="twitter:title" content={title} data-react-helmet="true"></meta>
        <meta property="twitter:description" content={desc} data-react-helmet="true"></meta>
        <meta property="twitter:image" content={image} data-react-helmet="true"></meta>
      </Helmet>
      <Navbar2 />
      <section id="blogs">
        <div className="blogs main">
          <div className="blogs-header pb-4">
            <Link to="/projects/" className="blog-back-link">
              <i className="fa-solid fa-arrow-left"></i>&nbsp;Back to Projects
            </Link>
            <h2 className="section-title">Cases</h2>
            <div className="blog-meta">
              <span>
                <i className="fa-solid fa-folder-open"></i>Worked investigations
                from my home lab
              </span>
            </div>
          </div>

          <p className="m-5">
            Each case is a full file: the scenario, how the evidence was
            handled, the analysis, and the paperwork that goes with it. All of
            the evidence comes from my own lab.
          </p>

          <div className="case-list">
            {CASES.map((c) => (
              <Link key={c.id} to={c.to} className="case-card">
                <div className="case-card__id">{c.id}</div>
                <h3 className="case-card__title">{c.title}</h3>
                <p className="case-card__text">{c.text}</p>
                <div className="case-chips">
                  <span className={`case-chip ${c.statusClass}`}>{c.status}</span>
                  {c.tools.map((t) => (
                    <span key={t} className="case-chip">
                      {t}
                    </span>
                  ))}
                </div>
                <div className="case-tags">
                  {c.docs.map((d) => (
                    <span key={d}>{d}</span>
                  ))}
                </div>
              </Link>
            ))}
          </div>
        </div>
        <Footer2 />
      </section>
    </div>
  );
}

export default Cases;
